/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface CheckRun
 */
export interface CheckRun {
    /**
     * 
     */
    check: string;
    /**
     * 
     */
    outcome: CheckRunOutcomeEnum;
    /**
     * Stable machine code identifying the result of the check. Each `check` name has its own enum (e.g. `GeoCheckCode` for `geo`). Consumers should narrow by `check` before interpreting.
     */
    code: string;
    /**
     * 
     */
    detail?: { [key: string]: any; };
    /**
     * 
     */
    ran_at: Date;
}


/**
 * @export
 */
export const CheckRunOutcomeEnum = {
    Accept: 'Accept',
    Reject: 'Reject',
    Maybe: 'Maybe',
    Pending: 'Pending',
    Cancelled: 'Cancelled',
    NA: 'N/A',
} as const;
export type CheckRunOutcomeEnum = typeof CheckRunOutcomeEnum[keyof typeof CheckRunOutcomeEnum];


/**
 * Check if a given object implements the CheckRun interface.
 */
export function instanceOfCheckRun(value: object): value is CheckRun {
    if (!('check' in value) || value['check'] === undefined) return false;
    if (!('outcome' in value) || value['outcome'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('ran_at' in value) || value['ran_at'] === undefined) return false;
    return true;
}

export function CheckRunFromJSON(json: any): CheckRun {
    return CheckRunFromJSONTyped(json, false);
}

export function CheckRunFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckRun {
    if (json == null) {
        return json;
    }
    return {
        
        'check': json['check'],
        'outcome': json['outcome'],
        'code': json['code'],
        'detail': json['detail'] == null ? undefined : json['detail'],
        'ran_at': (json['ran_at'] == null ? json['ran_at'] : parseDateTime(json['ran_at'])),
    };
}

export function CheckRunToJSON(json: any): CheckRun {
    return CheckRunToJSONTyped(json, false);
}

export function CheckRunToJSONTyped(value?: CheckRun | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'check': value['check'],
        'outcome': value['outcome'],
        'code': value['code'],
        'detail': value['detail'],
        'ran_at': value['ran_at'] == null ? value['ran_at'] : serializeDateTime(value['ran_at']),
    };
}

